import React, { PureComponent } from 'react';
import OfferTypeTabs from './components/tabs/index';
import HotelNameSearcher from './components/HotelNameSearcher';

import {
  createRegionsObject,
  fetchFilterData,
  isFilterExpired,
  localstorageAvailable
} from '../../services/services';
import { T } from '../../../../common/locale/translate';

export default class RegionsPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: null,
      regions: {},
      regions_list: [],
      special_regions: [],
      open_subregions: [],
      offer_type: props.offer_type || 'S',
      hotel_name: props.hotel_name
    };
  }

  componentDidMount = () => {
    this.setInitialData();
  };

  render() {
    const { params, not_found } = this.props;
    const breadcrumbs = this.state.breadcrumbs || this.props.breadcrumbs;
    let searcher = this.renderSearcher();
    let destinations = this.renderDestinations();

    return (
      <div className="regions-wrapper">
        <section className="offer-type-tabs">
          <OfferTypeTabs
            params={params}
            breadcrumbs={breadcrumbs}
            handleTabChange={offer_type => this.setState({ offer_type })}
          />
        </section>
        <div className="hotel-name-searcher">{searcher}</div>
        {not_found && (
          <div className="hotel-not-found">{T('no_hotels_found')}</div>
        )}
        <div className="regions-list">{destinations}</div>
      </div>
    );
  }

  renderSearcher = () => (
    <HotelNameSearcher
      offer_type={this.state.offer_type}
      initial_value={this.state.hotel_name}
    />
  );

  renderDestinations = () => {
    let main_destinations = this.state.regions.main_regions || [];
    return (
      <div>
        {this.renderDestinationGroups()}
        <div className="regions-group-header">
          <span> {T('all_directions')} </span>
        </div>
        <ul className="regions-group-wrapper">
          {this.renderDestinationElement(main_destinations)}
        </ul>
      </div>
    );
  };

  renderDestinationGroups = () => {
    let special_regions = this.state.special_regions;
    return special_regions.map((group, index) => (
      <div key={index}>
        <div className="regions-group-header">
          <span>
            {' '}
            {group.name} {T('destinations')}{' '}
          </span>
        </div>
        <ul className="regions-group-wrapper">
          {this.renderDestinationElement(group.subregions, 'special-regions')}
        </ul>
      </div>
    ));
  };

  renderDestinationElement = (destinations, nameSuffix) => {
    const suffix = nameSuffix ? nameSuffix : '';
    return destinations.map((region, i) => {
      const destination = this.state.regions[region];
      if (destination.subregions || !destination.parent) {
        // main region

        let isOpen = this.state.open_subregions.indexOf(destination.id) > -1;
        let arrow = destination.subregions ? (
          <i
            className={
              'subregions-indicator fa ' +
              (isOpen ? 'fa-chevron-up' : 'fa-chevron-down')
            }
            onClick={this.handleSubregionsIndicatorClick.bind(
              this,
              destination.id
            )}
          />
        ) : (
          ''
        );

        return (
          <li
            key={`left-${destination.id}`}
            className={'item parent-element ' + (isOpen ? 'open' : 'closed')}
          >
            <a
              href={`/hotele/${destination.slug}${
                this.state.offer_type == 'S'
                  ? ''
                  : `?offer_type=${this.state.offer_type}`
              }`}
            >
              {' '}
              {destination.name}{' '}
            </a>{' '}
            {arrow}
            {destination.subregions ? (
              <ul className="regions-group-wrapper child-wrapper">
                {' '}
                {this.renderDestinationElement(
                  destination.subregions,
                  suffix
                )}{' '}
              </ul>
            ) : (
              ''
            )}
          </li>
        );
      } else {
        // subregions

        return (
          <li key={`left-${destination.id}`} className="item child-element">
            <a
              href={`/hotele/${destination.slug}${
                this.state.offer_type == 'S'
                  ? ''
                  : `?offer_type=${this.state.offer_type}`
              }`}
            >
              {' '}
              {destination.name}{' '}
            </a>
          </li>
        );
      }
    });
  };

  handleSubregionsIndicatorClick = id => {
    if (this.state.open_subregions.indexOf(id) > -1) {
      let open_subregions = this.state.open_subregions.filter(v => v !== id);
      this.setState({ open_subregions }, () => {
        this.forceUpdate();
      });
    } else {
      let open_subregions = this.state.open_subregions;
      open_subregions.push(id);
      this.setState({ open_subregions }, () => {
        this.forceUpdate();
      });
    }
  };

  setInitialData = () => {
    if (localstorageAvailable()) {
      if (isFilterExpired('regions', this.state.filterDataCacheTime)) {
        this.updateFilterSource();
      } else {
        const filter_data = JSON.parse(localStorage.getItem('regions_filter'));
        this.setState({
          regions: filter_data.regions,
          regions_list: filter_data.regions_list,
          special_regions: filter_data.special_regions
        });
      }
    } else {
      this.updateFilterSource();
    }
  };

  updateFilterSource = () => {
    fetchFilterData('regions_filter').then(
      response => {
        const filter_data = createRegionsObject(response.data);
        if (localstorageAvailable()) {
          localStorage.setItem('regions_filter', JSON.stringify(filter_data));
          localStorage.setItem(
            'regions_filter_last_update',
            new Date().getTime()
          );
        }
        this.setState({
          regions: filter_data.regions,
          regions_list: filter_data.regions_list,
          special_regions: filter_data.special_regions
        });
      },
      error => {
        console.log('Error when fetching regions', error);
      }
    );
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/regions.jsx